import React, { useContext, useState, useEffect } from 'react';
import { ProductsContext } from '../context/products.context';
import EnhancedLaborMarketTable from './EnhancedLaborMarketTable';
import MyLaborMarketCharts from './MyLaborMarketCharts';

export const LaborMarketInfo = () => {
  const { jobs, isOpen, selectedLaborView } = useContext(ProductsContext);
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1650);
  const PANEL_WIDTH = 400; // width of your filter panel

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1650);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (
    !jobs ||
    (Array.isArray(jobs) && jobs.length === 0) ||
    Object.keys(jobs).length === 0
  ) {
    return (
      <div className="text-center p-4">
        No labor market data available at the moment.
      </div>
    );
  }

  // Only add spacer if not in charts view
  const spacerWidth = !isWideScreen && isOpen ? PANEL_WIDTH : 0;
  // On wide screens, optionally shift the main content by the panel width.
  const marginLeft = isWideScreen ? PANEL_WIDTH : 0;

  return (
    <div className="w-full flex mx-auto border-b-[12px] border-white bg-slate-50/25 px-4 min-h-full">
      {selectedLaborView !== 'charts' && (
        <div
          className="transition-all duration-300 bg-green-500 h-full"
          style={{ minWidth: `${spacerWidth}px`, marginLeft: `${marginLeft}px` }}
        />
      )}
      {selectedLaborView === 'charts' ? (
        <MyLaborMarketCharts />
      ) : (
        <EnhancedLaborMarketTable />
      )}
    </div>
  );
};